import React, { Component } from "react";
import OrganizationEvents, { Event, PageConfiguration } from "./index";
import CustomizeColors from "./CustomizeColors";
import PublishConfirmationAlert from "./PublishConfirmationAlert";
import ajax from "superagent";
import _, { lowerCase } from "lodash";
import ShareSocialPopup from "../ShareSocialPopup/index";
import { Navbar } from "./Navbar";
import { Cart } from "./types";
import Color from "color";
interface CustomizeLandingPageProps {
  eventsURL: string;
  completedEventsAvailable: boolean;
  upcomingEventsCount: Number;
  eventsView: string;
  organizerUserName: string;
  bulkRegisterCustomerLeadAPI: string;
  pageConfiguration: PageConfiguration;
  configurationPublishAPI: string;
  configurationSaveDraftAPI: string;
  updateEventCoverAPI: string;
  landingPageURL: string;
  organizationName: string;
  coversS3Bucket: string;
  bannerS3BasePath: string;
  eventCoverS3BasePath: string;
  showUpdateCoverOptionForEvent: number | null;
  isEventOrganizer: boolean;
  currentUser: {
    id: number;
    admin: boolean;
  };
  organizerId: number;
  embedGalleryURL: string;
  galleryURL: string;
  createEventURL: string;
  showCreateEventBanner: boolean;
  cartId: string;
  adminUser: boolean;
  selfieSearchS3Bucket: string;
  currentUserId: number;
  currentUserCountry: string;
  cart: Cart;
  photosAPI: string;
  addToCartAPI: string;
  removeFromCartAPI: string;
  organizationId: number;
  eventsAvailable: boolean;
  isAuthorizedForDirectDownloads: boolean;
  canManageTags: boolean;
  selfieSearchAvailable: boolean;
  securedGalleryView: boolean;
}

interface CustomizeLandingPageState {
  showPageColors: boolean;
  pageConfiguration: PageConfiguration;
  previewImage: string;
  imageProcessing: boolean;
  showPrimaryColorPicker: boolean;
  showSecondaryColorPicker: boolean;
  showAccentColorPicker: boolean;
  showSuccessAlert: boolean;
  updateCoverForEvent: Event | null;
  showShareGalleryModal: boolean;
  cart: Cart;
}

export interface OrganizationHeaderContextInterface {
  updateBanner: (url: string | null) => void;
  updateCroppedBanner: (url: string | null) => void;
  coversS3Bucket: string;
  bannerS3BasePath: string;
  eventCoverS3BasePath: string;
  currentUser: {
    id: number;
    admin: boolean;
  };
}

const OrganizationHeaderContext =
  React.createContext<OrganizationHeaderContextInterface | null>(null);

export const OrganizationHeaderContextConsumer =
  OrganizationHeaderContext.Consumer;

class CustomizeLandingPage extends Component<
  CustomizeLandingPageProps,
  CustomizeLandingPageState
> {
  constructor(props: CustomizeLandingPageProps) {
    super(props);
    this.state = {
      showPageColors: false,
      pageConfiguration: props.pageConfiguration,
      previewImage: "",
      imageProcessing: false,
      showPrimaryColorPicker: false,
      showSecondaryColorPicker: false,
      showSuccessAlert: false,
      showAccentColorPicker: false,
      updateCoverForEvent: null,
      showShareGalleryModal: false,
      cart: props.cart
    };

    this.toggleColorsPanel = this.toggleColorsPanel.bind(this);
    this.publish = this.publish.bind(this);
    this.saveDraft = this.saveDraft.bind(this);
    this.handleSaveAndPublish = this.handleSaveAndPublish.bind(this);
    this.updateBanner = this.updateBanner.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
  }

  public componentDidMount() {
    $("#customize-landing-page").ready(() => {
      $("#customize-landing-placeholder").hide();
    });
    $("body").on("contextmenu", function (e) {
      return false;
    });
  }

  public render() {
    return (
      <OrganizationHeaderContext.Provider
        value={{
          updateBanner: this.updateBanner,
          updateCroppedBanner: this.updateCroppedBanner,
          coversS3Bucket: this.props.coversS3Bucket,
          bannerS3BasePath: this.props.bannerS3BasePath,
          eventCoverS3BasePath: this.props.eventCoverS3BasePath,
          currentUser: this.props.currentUser
        }}
      >
        <div id="customize-landing-page">
          <Navbar
            landingPageURL={this.props.landingPageURL}
            showShareGalleryPopup={() =>
              this.setState({ showShareGalleryModal: true })
            }
            embedGalleryURL={this.props.embedGalleryURL}
            toggleColorsPanel={this.toggleColorsPanel}
            handleSaveAndPublish={this.handleSaveAndPublish}
            showPageColors={this.state.showPageColors}
          />
          <CustomizeColors
            showPageColors={this.state.showPageColors}
            pageConfiguration={this.state.pageConfiguration}
            handleColorChange={this.handleColorChange}
            initialPageConfiguration={this.props.pageConfiguration}
            hidePageColors={() => this.setState({ showPageColors: false })}
          />
          <OrganizationEvents
            customizePage={true}
            eventsURL={this.props.eventsURL}
            completedEventsAvailable={this.props.completedEventsAvailable}
            upcomingEventsCount={this.props.upcomingEventsCount}
            organizerUserName={this.props.organizerUserName}
            organizerEmail={""}
            bulkRegisterCustomerLeadAPI={this.props.bulkRegisterCustomerLeadAPI}
            pageConfiguration={this.state.pageConfiguration}
            editMode={true}
            eventsView={this.props.eventsView}
            organizationName={this.props.organizationName}
            embedMode={false}
            isEventOrganizer={this.props.isEventOrganizer}
            createEventURL={this.props.createEventURL}
            showCreateEventBanner={this.props.showCreateEventBanner}
            cartId={this.props.cartId}
            adminUser={this.props.adminUser}
            selfieSearchS3Bucket={this.props.selfieSearchS3Bucket}
            currentUserId={this.props.currentUserId}
            currentUserCountry={this.props.currentUserCountry}
            cart={this.props.cart}
            photosAPI={this.props.photosAPI}
            addToCartAPI={this.props.addToCartAPI}
            removeFromCartAPI={this.props.removeFromCartAPI}
            organizationId={this.props.organizationId}
            organizerId={this.props.organizerId}
            secureAccessToken={null}
            isAuthorizedForDirectDownloads={
              this.props.isAuthorizedForDirectDownloads
            }
            updateEventCoverAPI={this.props.updateEventCoverAPI}
            eventsAvailable={this.props.eventsAvailable}
            canManageTags={this.props.canManageTags}
            selfieSearchAvailable={this.props.selfieSearchAvailable}
            showSellYourPhotosModal={false}
            securedGalleryView={this.props.securedGalleryView}
          />
          {this.state.showSuccessAlert && (
            <PublishConfirmationAlert
              landingPageURL={this.props.landingPageURL}
              pageConfiguration={this.state.pageConfiguration}
              closeAlert={() => {
                this.setState({ showSuccessAlert: false });
              }}
            />
          )}
          {this.state.showShareGalleryModal && (
            <ShareSocialPopup
              galleryURL={this.props.galleryURL}
              hideShareGalleryModal={() =>
                this.setState({ showShareGalleryModal: false })
              }
              text={"Share with participants or just show off ;)"}
            />
          )}
        </div>
      </OrganizationHeaderContext.Provider>
    );
  }

  public updateBanner = (url: string) => {
    this.setState({
      pageConfiguration: {
        ...this.state.pageConfiguration,
        bannerUrl: url,
        croppedBannerURL: null
      }
    });
  };

  public updateCroppedBanner = (url: string) => {
    this.setState({
      pageConfiguration: {
        ...this.state.pageConfiguration,
        croppedBannerURL: url
      }
    });
  };

  public handleColorChange = (colorType: string, color: string) => {
    this.setState({
      pageConfiguration: {
        ...this.state.pageConfiguration,
        [colorType]: color
      }
    });
  };

  private toggleColorsPanel() {
    this.setState({
      showPageColors: !this.state.showPageColors
    });
  }

  private publish() {
    ajax
      .post(this.props.configurationPublishAPI)
      .send({
        landing_page_settings: this.state.pageConfiguration,
        organizer_id: this.props.organizerId
      })
      .then(res => {
        this.setState({ showSuccessAlert: true });
      })
      .catch(e => {
        // @ts-ignore
        toastr.error(
          "Error publishing changes. Please try again later.",
          null,
          { timeOut: 3000 }
        );
      });
  }

  private handleSaveAndPublish = (action: string) => {
    const { primaryColor, secondaryColor } = this.state.pageConfiguration;
    const allowedColors = ["#c1ebed"];

    const isColorLight = [primaryColor, secondaryColor].some(
      color =>
        !allowedColors.includes(color.toLowerCase()) &&
        (Color(color).darken(0.5).isLight() ||
          color.toLowerCase() === "#ffffff")
    );
    if (isColorLight) {
      // @ts-ignore
      toastr.error("Change color to a darker color to save", null, {
        timeOut: 3000
      });
    } else if (action === "save") {
      this.saveDraft();
    } else if (action === "publish") {
      this.publish();
    }
  };

  private saveDraft() {
    ajax
      .post(this.props.configurationSaveDraftAPI)
      .send({
        landing_page_settings_draft: this.state.pageConfiguration,
        organizer_id: this.props.organizerId
      })
      .then(res => {
        // @ts-ignore
        toastr.success("Changes saved as draft", null, { timeOut: 1000 });
      })
      .catch(e => {
        // @ts-ignore
        toastr.error("Error saving draft. Please try again later.", null, {
          timeOut: 3000
        });
      });
  }
}

export default CustomizeLandingPage;
